import { useIntl } from 'react-intl';
import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';

import { EmptyStateIcon } from './empty-state-icon';
import { messages } from './messages';
import style from './style.module.less';

export const NotificationEmptyState = () => {
  const intl = useIntl();

  return (
    <FlexColumn className={style['empty-state']} gap={Gap.Space24}>
      <div className={style['icon-container']}>
        <EmptyStateIcon />
      </div>
      <FlexColumn className={style['text-container']}>
        <Text className={style.title} element='div' textType={TextType.H4} value={intl.formatMessage(messages.title)} />
        <Text className={style.description} element='div' textType={TextType.Paragraph} value={intl.formatMessage(messages.description)} />
      </FlexColumn>
    </FlexColumn>
  );
};
